import { useState } from "react";

export default function CPCInsightsPage() {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div className="h-screen w-full">
      {isLoading && (
        <div className="flex items-center justify-center h-full">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
        </div>
      )}
      <iframe
        src={`https://cpc.project.sg/dashboard?utm_source=projectsg&utm_medium=iframe&utm_campaign=psg_cpc_7hK3n9qX`}
        style={{
          minHeight: "100svh",
        }}
        className={`w-full min-h-screen flex justify-center items-center h-full border-0 ${isLoading ? "hidden" : ""}`}
        title="Ad Report"
        onLoad={() => setIsLoading(false)}
      />
    </div>
  );
}
